<template>
    <div class="container">
        <div class="card-table-container" v-loading="loading" :style="cardTableStyle">
            <div class="row-container" v-if="tableList.data.length==0">
                <div class="table-header">
                    <el-row>
                        <el-col v-for="(column, cIndex) in columns" :key="cIndex" :span="column.headerSpan||column.span">{{column.label}}</el-col>
                    </el-row>
                </div>
                <div class="el-table__empty-block" >
                    <span class="el-table__empty-text">暂无数据</span>
                </div>
            </div>
            <div class="row-container" v-for="(item, i) in tableList.data" :key="i">
                <div class="table-header" v-if="i==0">
                    <el-row>
                        <el-col v-for="(column, cIndex) in columns" :key="cIndex" :span="column.headerSpan||column.span" :style="column.style">{{column.label}}</el-col>
                    </el-row>
                </div>
                <div>
                    <slot name="row-header" v-bind:rowData="item"></slot>
                    <el-row>
                        <el-col v-for="(column, cIndex) in columns" :key="cIndex" :span="column.span" :style="column.style">
                            <span v-if="!$scopedSlots['custom-column-'+column.prop]">{{item[column.prop]}}</span>
                            <slot :name="'custom-column-'+column.prop" v-bind:rowData="item"></slot>
                        </el-col>
                    </el-row>
                    <slot name="row-footer" v-bind:rowData="item"></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "DataCardTable",
        props: {
            tableList: {
                type: Object,
            },
            columns: {
                type: Array,
                default() {
                    return [];
                }
            },
            cardTableStyle: String
        },
        data() {
           return {
               loading: false,
           }
        },
        methods: {
            handlePageSizeChange(val)
            {
                this.load();
            },
            handlePageChange(val)
            {
                this.load();
            },
            load()
            {
                this.loading = true;
                return this.tableList.load().then(()=>this.loading=false);
            },
        }
    }
</script>

<style scoped>
    .container {
        margin-bottom: 30px;
    }
    .card-table-container {
        /*background-color: bisque;*/
        flex-direction: column;
        display: flex;
        font-size: 15px;
    }
    .card-table-container .el-row {
        display: flex;
        align-items: center;
    }
    .table-header {
        border-bottom: 1px solid #EBEEF5;
        padding-bottom: 10px;
        margin-bottom: 10px;
        color: #909399;
        font-size: 15px;
        font-weight: 700;
    }
    .row-container {
        /* margin-top: 10px; */
        background-color: white;
        box-shadow: 0px 0px 3px rgba(81, 81, 81, 0.149019607843137);
        padding: 10px;
        flex: 1;
        font-size: 15px;
    }
    .row-container .el-col {
        min-height: 10px;
    }

    .card-table-container .row-container .el-row .el-button{
        margin: 3px;
    }
</style>



// WEBPACK FOOTER //
// src/components/table/DataCardTable.vue